/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */
/* eslint no-undef       : 0 */
/* eslint camelcase      : 0 */

import User from '@/core/user'

export default {
  setup() {
    //
  },

  logout() {
    // window.embedded_svc && embedded_svc.liveAgentAPI.endChat()
    window.embedded_svc && window.embedded_svc.liveAgentAPI.clearSession()
    document.getElementById('salesforceChatBot') && document.getElementById('salesforceChatBot').remove()
  },

  init() {
    if (window.salesforceInit) return
    if (window.self !== window.top) return
    var initESW = function(gslbBaseURL) {
      embedded_svc.settings.displayHelpButton = true
      embedded_svc.settings.language = ''

      embedded_svc.settings.enabledFeatures = ['LiveAgent']
      embedded_svc.settings.entryFeature = 'LiveAgent'

      const user = User.get()
      let firstName = user.user && user.user.FirstName
      let email = user.user && user.user.Email
      let customerType = user.data && parseInt(user.data.MarketTypeID) === 3 ? 'supplier' : 'corporate'
      embedded_svc.settings.extraPrechatFormDetails = [
        {
          'label':'First Name',
          'value':firstName,
          'transcriptFields': ['First_Name__c'],
          'displayToAgent': true
        }, {
          'label':'Email',
          'value':email,
          'transcriptFields': ['Email__c'],
          'displayToAgent': true
        }, {
          'label':'Customer Type',
          'value':customerType,
          'transcriptFields': ['Customer_Type__c'],
          'displayToAgent': true
        }
      ]

      embedded_svc.init(
        'https://eved.my.salesforce.com',
        'https://eved.my.site.com/Client',
        gslbBaseURL,
        '00DA0000000JnaI',
        'Chat_Team',
        {
          baseLiveAgentContentURL: 'https://c.la4-c1-ia5.salesforceliveagent.com/content',
          deploymentId: '5725c000000LLN9',
          buttonId: '5735c000000LMO4',
          baseLiveAgentURL: 'https://d.la4-c1-ia5.salesforceliveagent.com/chat',
          eswLiveAgentDevName: 'Chat_Team',
          isOfflineSupportEnabled: true
        }
      )
    }

    if (!window.embedded_svc && !window.salesforceInit) {
      var s = document.createElement('script')
      s.setAttribute('id', 'salesforceChatBot')
      s.setAttribute('src', 'https://eved.my.salesforce.com/embeddedservice/5.0/esw.min.js')
      s.onload = function() {
        if (!embedded_svc) {
          setTimeout(() => {
            initESW(null)
          }, 1000)
        } else {
          initESW(null)
        }
      }
      document.body.appendChild(s)
    } else {
      if (!embedded_svc) {
        setTimeout(() => {
          initESW('https://service.force.com')
        }, 1000)
      } else {
        initESW('https://service.force.com')
      }
    }
    window.salesforceInit = true
  }
}



// WEBPACK FOOTER //
// ./src/components/salesforce/index.js